import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportDailyReportsExcel = (
    reports = [],
    summary = {},
    period = "Reporte",
    userName = "Sistema"
) => {

    //----------------------------------
    // CREAR LIBRO
    //----------------------------------

    const wb = XLSX.utils.book_new();

    //----------------------------------
    // HOJA RESUMEN
    //----------------------------------

    const resume = [

        ["MAQCONTROL ERP"],
        ["REPORTE DE PARTES DIARIOS"],
        [],
        ["Período", period],
        ["Generado por", userName],
        ["Fecha", new Date().toLocaleString("es-BO")],
        [],
        ["RESUMEN"],
        ["Total Reportes", summary?.totalReports || reports.length],
        ["Horas Trabajadas", summary?.totalHours || 0],
        ["Combustible Consumido", summary?.totalFuel || 0],
        ["Total Maquinarias", summary?.totalMachines || 0],
        ["Total Operadores", summary?.totalOperators || 0]

    ];

    const wsResume = XLSX.utils.aoa_to_sheet(resume);

    wsResume["!cols"] = [
        { wch: 30 },
        { wch: 30 }
    ];

    wsResume["!merges"] = [
        {
            s: { r: 0, c: 0 },
            e: { r: 0, c: 3 }
        },
        {
            s: { r: 1, c: 0 },
            e: { r: 1, c: 3 }
        }
    ];

    XLSX.utils.book_append_sheet(
        wb,
        wsResume,
        "Resumen"
    );

    //----------------------------------
    // HOJA DETALLE
    //----------------------------------

    const detail = reports.map((r, index) => ({

        "N°": index + 1,

        Fecha: r.date || "",

        Proyecto:
            r.project_name ||
            r.project ||
            "",

        Maquinaria:
            r.machine_name ||
            r.machinery_name ||
            "",

        Operador:
            r.operator_name ||
            "",

        Horómetro:
            r.hourmeter ||
            "",

        "Horas Trabajadas":
            Number(r.hours_worked || 0),

        "Combustible (L)":
            Number(
                r.diesel_consumed ||
                r.fuel_consumed ||
                0
            ),

        Actividad:
            r.activity ||
            "",

        Observaciones:
            r.observations ||
            ""

    }));

    const wsDetail =
        XLSX.utils.json_to_sheet(detail);

    wsDetail["!cols"] = [

        { wch: 8 },

        { wch: 14 },

        { wch: 28 },

        { wch: 28 },

        { wch: 25 },

        { wch: 15 },

        { wch: 18 },

        { wch: 18 },

        { wch: 40 },

        { wch: 45 }

    ];

    if (wsDetail["!ref"]) {

        wsDetail["!autofilter"] = {
            ref: wsDetail["!ref"]
        };

    }

    XLSX.utils.book_append_sheet(
        wb,
        wsDetail,
        "Detalle"
    );

    //----------------------------------
    // HOJA ESTADÍSTICAS
    //----------------------------------

    const stats = [

        ["ESTADÍSTICAS"],

        [],

        ["Total Reportes",
            summary?.totalReports || reports.length],

        ["Horas Trabajadas",
            summary?.totalHours || 0],

        ["Combustible Consumido",
            summary?.totalFuel || 0],

        ["Total Maquinarias",
            summary?.totalMachines || 0],

        ["Total Operadores",
            summary?.totalOperators || 0]

    ];

    const wsStats =
        XLSX.utils.aoa_to_sheet(stats);

    wsStats["!cols"] = [

        { wch: 35 },

        { wch: 20 }

    ];

    XLSX.utils.book_append_sheet(
        wb,
        wsStats,
        "Estadísticas"
    );

    //----------------------------------
    // EXPORTAR
    //----------------------------------

    const buffer = XLSX.write(
        wb,
        {

            bookType: "xlsx",

            type: "array"

        }
    );

    const fileName =
        `MAQCONTROL_Reporte_Partes_${(period || "Reporte")
            .replace(/\s+/g, "_")
            .replace(/\//g, "-")}.xlsx`;

    saveAs(

        new Blob(
            [buffer],
            {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        ),

        fileName

    );

};